// import axios from "axios";
// import {
//   POST_GENERATE_QUESTIONS,
//   POST_GENERATE_CORRECT_ANSWERS,
//   GET_SUBJCET_CHAPTER,
//   GET_ASSESSMENT_HISTORY,
//   GET_FUTURE_ASSESSMENT,
//   POST_FUTURE_ASSESSMENT_QUESTIONS,
//   POST_SUBMIT_TEST,
//   GET_SHOW_TEST_RESULT,
//   GET_ASSIGNMENT_IN_PROGRESS,
//   GET_ASSIGNMENT_HISTORY_NOT_ATTEMPTED,
// } from "../../utils/api";
// import {
//   GENERATE_TEST_FAILURE,
//   GENERATE_TEST_SUCCESS,
//   TEST_RESULT_SUCCESS,
//   TEST_RESULT_FAILURE,
//   CORRECT_ANSWERS_FAILURE,
//   SUBJECT_CHAPTER_SUCCESS,
//   SUBJECT_CHAPTER_FAILURE,
//   HISTORY_SUCCESS,
//   HISTORY_FAILURE,
//   FUTURE_ASSIGNMENT_SUCCESS,
//   FUTURE_ASSIGNMENT_FAILURE,
//   FUTURE_ASSIGNMENT_QUESTIONS_SUCCESS,
//   FUTURE_ASSIGNMENT_QUESTIONS_FAILURE,
//   SUBMIT_ANSWERS_FAILURE,
//   SUBMIT_ANSWERS_SUCCESS,
//   SEE_ANSWERS_FAILURE,
//   SEE_ANSWERS_SUCCESS,
//   ASSIGNMENT_IN_PROGRESS_FAILURE,
//   ASSIGNMENT_IN_PROGRESS_SUCCESS,
//   HISTORY_NOT_ATTEMPTED_SUCCESS,
//   HISTORY_NOT_ATTEMPTED_FAILURE,
// } from "./test.actionTypes";

// export const finalResults = (payload) => async (dispatch) => {
//   const userAnswers = payload.selectedAnswers;
//  const user_answers = Array.isArray(userAnswers)
//   ? userAnswers
//   : Object.keys(userAnswers)
//       .sort((a, b) => Number(a) - Number(b))
//       .map(k => userAnswers[k]);

//   const data = {
//       assignment_id: payload.assignment_id,
//       user_answers: user_answers,
//       context: payload.context,
//       questions :payload.questions
//   };

//    const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//     "Content-Type": "application/json",
//   };

//   try {
//     const resp = await axios.post(POST_GENERATE_CORRECT_ANSWERS, data, {
//       headers,
//       withCredentials: true,
//     }); 
    
  
//     if (resp.data) {
//       const percent = resp?.data?.percentage;
//       dispatch({
//         type: TEST_RESULT_SUCCESS,
//         payload: {
//           response: resp.data
//         },
//       });
//       return percent;
//     } else {
//       dispatch({
//         type: TEST_RESULT_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     console.error("Unable to process request. Please try later!", error);
//     dispatch({
//       type: CORRECT_ANSWERS_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

// export const getSubjectChapter = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//     // "Content-Type": "multipart/form-data",
//   };
//   try {
//     const resp = await axios.get(GET_SUBJCET_CHAPTER, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: SUBJECT_CHAPTER_SUCCESS,
//         payload: resp.data,
//       });
//     } else {
//       dispatch({
//         type: SUBJECT_CHAPTER_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: SUBJECT_CHAPTER_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

// export const generateQuestions = (payLoad, selectedSubject, selectedChapters) => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//     "Content-Type": "application/json",
//   };

//   try {
//     const resp = await axios.post(POST_GENERATE_QUESTIONS, payLoad, {
//       headers,
//       withCredentials: true,
//     });

//     if (resp.status === 200) {
//       dispatch({
//         type: GENERATE_TEST_SUCCESS,
//         payload: {
//           data: resp.data,
//            subjectName: selectedSubject, 
//            chapterArray: selectedChapters
//         },
//       });
//       return resp.data
//     } else {
//       dispatch({
//         type: GENERATE_TEST_FAILURE,
//         payload: {
//           message: resp?.data?.message,
//         },
//       });
//     }
//   } catch (error) {
//     console.error("Unable to process request. Please try later!", error);
//     dispatch({
//       type: GENERATE_TEST_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

// export const assessmentHistory = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.get(GET_ASSESSMENT_HISTORY, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: HISTORY_SUCCESS,
//         payload: resp.data,
//       });
//     } else {
//       dispatch({
//         type: HISTORY_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: SUBJECT_CHAPTER_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

// export const futureAssignment = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.get(GET_FUTURE_ASSESSMENT, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: FUTURE_ASSIGNMENT_SUCCESS,
//         payload: resp.data,
//       });
//     } else {
//       dispatch({
//         type: FUTURE_ASSIGNMENT_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: FUTURE_ASSIGNMENT_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

// export const FutureAssessmentQuestions = (payload) => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.post(POST_FUTURE_ASSESSMENT_QUESTIONS,payload, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//           dispatch({
//         type: FUTURE_ASSIGNMENT_QUESTIONS_SUCCESS,
//         payload: resp.data,
//       });
//       return {success: true, data: resp.data}

    
//     } 
//   } catch (error) {
//     dispatch({
//       type: FUTURE_ASSIGNMENT_QUESTIONS_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//     return {success: false, resp: error}
//   }
// };

// export const submitAnswers = (payload, id) => async (dispatch) => {
//   const userAnswers = payload.answers;
//  const user_answers = Array.isArray(userAnswers)
//   ? userAnswers
//   : Object.keys(userAnswers)
//       .sort((a, b) => Number(a) - Number(b))
//       .map(k => userAnswers[k]);

//   const data = {
//       answers: user_answers,
//   };

//    const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//     "Content-Type": "application/json",
//   };

//   try {
//     const resp = await axios.post(`${POST_SUBMIT_TEST}/${id}`, data, {
//       headers,
//       withCredentials: true,
//     }); 
    
//     if (resp.data) {
//     const percent = resp?.data?.percentage;
//       dispatch({
//         type: SUBMIT_ANSWERS_SUCCESS,
//         payload: {
//           response: resp.data
//         },
//       });
//       // return percent;
//       return {success: true, response: resp.data}
//       }
//    else {
//       dispatch({
//         type: SUBMIT_ANSWERS_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//        return {success: false, response: resp?.data?.msg}
//     }
//   } catch (error) {
//     console.error("Unable to process request. Please try later!", error);
//     dispatch({
//       type: SUBMIT_ANSWERS_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

// export const seeAllAnswers = (id) => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.get(`${GET_SHOW_TEST_RESULT}/${id}`, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: SEE_ANSWERS_SUCCESS,
//         payload: resp.data,
//       });
//        return {success: true, data: resp.data}
//     } else {
//       dispatch({
//         type: SEE_ANSWERS_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: SEE_ANSWERS_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

// export const assignmentInProgress = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.get(GET_ASSIGNMENT_IN_PROGRESS, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: ASSIGNMENT_IN_PROGRESS_SUCCESS,
//         payload: resp.data,
//       });
//     } else {
//       dispatch({
//         type: ASSIGNMENT_IN_PROGRESS_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: ASSIGNMENT_IN_PROGRESS_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

// export const assessmentHistoryNotAttempted = () => async (dispatch) => {
//  const token = localStorage.getItem("access_token") || null;
//   const headers = {
//     Authorization: `Bearer ${token}`,
//   };
//   try {
//     const resp = await axios.get(GET_ASSIGNMENT_HISTORY_NOT_ATTEMPTED, {
//       headers,
//       withCredentials: true,
//     });
  
//     if (resp.status === 200) {
//       dispatch({
//         type: HISTORY_NOT_ATTEMPTED_SUCCESS,
//         payload: resp.data,
//       });
//     } else {
//       dispatch({
//         type: HISTORY_NOT_ATTEMPTED_FAILURE,
//         payload: {
//           message: resp?.data?.msg,
//         },
//       });
//     }
//   } catch (error) {
//     dispatch({
//       type: HISTORY_NOT_ATTEMPTED_FAILURE,
//       payload: {
//         message: error,
//       },
//     });
//   }
// };

import { apiRequest } from "../../api/apiRequest";
import {
  POST_GENERATE_QUESTIONS,
  POST_GENERATE_CORRECT_ANSWERS,
  GET_SUBJCET_CHAPTER,
  GET_ASSESSMENT_HISTORY,
  GET_FUTURE_ASSESSMENT,
  POST_FUTURE_ASSESSMENT_QUESTIONS,
  POST_SUBMIT_TEST,
  GET_SHOW_TEST_RESULT,
  GET_ASSIGNMENT_IN_PROGRESS,
  GET_ASSIGNMENT_HISTORY_NOT_ATTEMPTED,
} from "../../utils/api";
import {
  GENERATE_TEST_FAILURE,
  GENERATE_TEST_SUCCESS,
  TEST_RESULT_SUCCESS,
  TEST_RESULT_FAILURE,
  CORRECT_ANSWERS_FAILURE,
  SUBJECT_CHAPTER_SUCCESS,
  SUBJECT_CHAPTER_FAILURE,
  HISTORY_SUCCESS,
  HISTORY_FAILURE,
  FUTURE_ASSIGNMENT_SUCCESS,
  FUTURE_ASSIGNMENT_FAILURE,
  FUTURE_ASSIGNMENT_QUESTIONS_SUCCESS,
  FUTURE_ASSIGNMENT_QUESTIONS_FAILURE,
  SUBMIT_ANSWERS_FAILURE,
  SUBMIT_ANSWERS_SUCCESS,
  SEE_ANSWERS_FAILURE,
  SEE_ANSWERS_SUCCESS,
  ASSIGNMENT_IN_PROGRESS_FAILURE,
  ASSIGNMENT_IN_PROGRESS_SUCCESS,
  HISTORY_NOT_ATTEMPTED_SUCCESS,
  HISTORY_NOT_ATTEMPTED_FAILURE,
} from "./test.actionTypes";

export const finalResults = (payload) => async (dispatch) => {
  const userAnswers = payload.selectedAnswers;
  const user_answers = Array.isArray(userAnswers)
    ? userAnswers
    : Object.keys(userAnswers)
        .sort((a, b) => Number(a) - Number(b))
        .map((k) => userAnswers[k]);

  const data = {
    assignment_id: payload.assignment_id,
    user_answers: user_answers,
    context: payload.context,
    questions: payload.questions,
  };

  const result = await apiRequest("post", POST_GENERATE_CORRECT_ANSWERS, data);

 if (result.success) {
    const percent = result?.data?.percentage;
    dispatch({
      type: TEST_RESULT_SUCCESS,
      payload: { response: result.data },
    });
    return { success: true, score: percent };
  } else {
    dispatch({
      type: CORRECT_ANSWERS_FAILURE,
      payload: { message: result.message },
    });
    return { success: false, message: result.message };
  }
};

export const getSubjectChapter = () => async (dispatch) => {
  const result = await apiRequest("get", GET_SUBJCET_CHAPTER);

  if (result.success) {
    dispatch({
      type: SUBJECT_CHAPTER_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: SUBJECT_CHAPTER_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const generateQuestions =
  (payLoad, selectedSubject, selectedChapters) => async (dispatch) => {
    const result = await apiRequest("post", POST_GENERATE_QUESTIONS, payLoad);

    if (result.success) {
      dispatch({
        type: GENERATE_TEST_SUCCESS,
        payload: {
          data: result.data,
          subjectName: selectedSubject,
          chapterArray: selectedChapters,
        },
      });
      return result.data;
    } else {
      dispatch({
        type: GENERATE_TEST_FAILURE,
        payload: {
          message: result.message,
        },
      });
    }
  };

export const assessmentHistory = () => async (dispatch) => {
  const result = await apiRequest("get", GET_ASSESSMENT_HISTORY);

  if (result.success) {
    dispatch({
      type: HISTORY_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: HISTORY_SUCCESS,
      payload: {
        message: result.message,
      },
    });
  }
};

export const futureAssignment = () => async (dispatch) => {
  const result = await apiRequest("get", GET_FUTURE_ASSESSMENT);

  if (result.success) {
    dispatch({
      type: FUTURE_ASSIGNMENT_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: FUTURE_ASSIGNMENT_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const FutureAssessmentQuestions = (payload) => async (dispatch) => {
  const result = await apiRequest(
    "post",
    POST_FUTURE_ASSESSMENT_QUESTIONS,
    payload
  );

  if (result.success) {
    dispatch({
      type: FUTURE_ASSIGNMENT_QUESTIONS_SUCCESS,
      payload: result.data,
    });
    return { success: true, data: result.data };
  } else {
    dispatch({
      type: FUTURE_ASSIGNMENT_QUESTIONS_FAILURE,
      payload: {
        message: result.message,
      },
    });
    return { success: false, resp: result.message };
  }
};

export const submitAnswers = (payload, id) => async (dispatch) => {
  const userAnswers = payload.answers;
  const user_answers = Array.isArray(userAnswers)
    ? userAnswers
    : Object.keys(userAnswers)
        .sort((a, b) => Number(a) - Number(b))
        .map((k) => userAnswers[k]);

  const data = {
    answers: user_answers,
  };

  const result = await apiRequest("post", `${POST_SUBMIT_TEST}/${id}`, data);

  if (result.success) {
    dispatch({
      type: SUBMIT_ANSWERS_SUCCESS,
      payload: {
        response: result.data,
      },
    });
    return { success: true, response: result.data };
  } else {
    dispatch({
      type: SUBMIT_ANSWERS_FAILURE,
      payload: {
        message: result.message,
      },
    });
    return { success: false, response: result.message };
  }
};

export const seeAllAnswers = (id) => async (dispatch) => {
  const result = await apiRequest("get", `${GET_SHOW_TEST_RESULT}/${id}`);

  if (result.success) {
    dispatch({
      type: SEE_ANSWERS_SUCCESS,
      payload: result.data,
    });
    return { success: true, data: result.data };
  } else {
    dispatch({
      type: SEE_ANSWERS_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const assignmentInProgress = () => async (dispatch) => {
  const result = await apiRequest("get", GET_ASSIGNMENT_IN_PROGRESS);

  if (result.success) {
    dispatch({
      type: ASSIGNMENT_IN_PROGRESS_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: ASSIGNMENT_IN_PROGRESS_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};

export const assessmentHistoryNotAttempted = () => async (dispatch) => {
  const result = await apiRequest("get", GET_ASSIGNMENT_HISTORY_NOT_ATTEMPTED);

  if (result.success) {
    dispatch({
      type: HISTORY_NOT_ATTEMPTED_SUCCESS,
      payload: result.data,
    });
  } else {
    dispatch({
      type: HISTORY_NOT_ATTEMPTED_FAILURE,
      payload: {
        message: result.message,
      },
    });
  }
};